import {ref, computed} from 'vue'
import {defineStore} from 'pinia'

export default defineStore('chat', () => {
  const items = ref([])
  const mark = ref(new Date(0).toISOString())
  const preview = ref('')
  const isDisabledChat = ref(false)

  const read = computed(() => items.value.filter(item => new Date(item.timestamp) <= new Date(mark.value)))
  const unread = computed(() => items.value.filter(item => new Date(item.timestamp) > new Date(mark.value)))

  function addMessage(message) {
    items.value.push(message)
  }
  function clearMessages() {
    items.value.splice(0, items.value.length)
  }
  function previewMessage(preview) {
    this.$patch({preview})
  }

  function markRead() {
    mark.value = new Date().toISOString()
  }

  function updateStatusChat(isDisabledChat) {
    this.$patch({isDisabledChat})
  }

  return {
    read,
    unread,
    preview,
    addMessage,
    previewMessage,
    isDisabledChat,
    updateStatusChat,
    markRead,
    clearMessages,
  }
})
